<template>
  <div class="exam-set-page">
    <div class="search-box" v-auth="'examSetting_/examinationSetting/pageList'">
      <el-cascader
        size="mini"
        clearable
        v-model="courseIds"
        :show-all-levels="false"
        :props="subjectTreeProps"
        placeholder="请输入所属科目"
        :options="subjectTreeList"
        @change="subjectSearchChange(0)"
      ></el-cascader>
      <el-select
        size="mini"
        style="margin-left: 20px"
        v-model="classInfoId"
        clearable
        placeholder="选择考试期数"
        @change="optionsChange"
      >
        <el-option
          v-for="item in options"
          :key="item.id"
          :label="item.sequenceText"
          :value="item.sequence"
        ></el-option>
      </el-select>
      <el-button size="mini" style="margin-left: 20px" type="primary" @click="search"
        >查询</el-button
      >
    </div>
    <div class="secend-btn">
      <el-button
        size="mini"
        type="primary"
        @click="addTestDia = true"
        v-auth="'examSetting_/examinationSetting/addExaminationSetting'"
        >添加考试</el-button
      >
      <el-button
        size="mini"
        type="primary"
        @click="addCapture"
        v-auth="'examSetting_/examinationPhotoSetting/getExaminationPhotoSetting'"
        >抓拍设置</el-button
      >
      <el-button
        size="mini"
        @click="clearTestCache"
        v-auth="'examSetting_/examinationSetting/cleanExaminationExamQuestionCache'"
        >清除试卷缓存</el-button
      >
    </div>

    <el-table
      :data="testList"
      border
      style="width: 100%"
      v-auth="'examSetting_/examinationSetting/pageList'"
    >
      <el-table-column
        prop="subjectName"
        label="考试项目"
        :show-overflow-tooltip="true"
      ></el-table-column>
      <el-table-column label="考试期数" :show-overflow-tooltip="true">
        <template slot-scope="scope">
          <span>第{{ scope.row.sequence }}期</span>
        </template>
      </el-table-column>
      <el-table-column
        prop="name"
        label="试卷设置"
        width="90"
        :show-overflow-tooltip="true"
      >
        <template slot-scope="scope">
          <span
            :style="[
              {
                color:
                  scope.row.settingExamCount < scope.row.totalExamCount ? 'red' : null,
              },
            ]"
            >{{ scope.row.settingExamCount }}/{{ scope.row.totalExamCount }}</span
          >
        </template>
      </el-table-column>
      <el-table-column label="报名日期" :show-overflow-tooltip="true" width="300">
        <template slot-scope="scope">
          <span
            >{{ scope.row.signBeginTime.slice(0, 16) }}&nbsp;至&nbsp;{{
              scope.row.signEndTime.slice(0, 16)
            }}</span
          >
        </template>
      </el-table-column>
      <el-table-column label="状态" :show-overflow-tooltip="true"
        ><template slot-scope="scope">
          <span v-if="scope.row.examState == 1">未开始报名</span>
          <span v-if="scope.row.examState == 2" style="color: #24d2b5">报名中</span>
          <span v-if="scope.row.examState == 3" style="color: #a2aabc">报名已结束</span>
        </template></el-table-column
      >
      <el-table-column label="操作" :show-overflow-tooltip="true">
        <template slot-scope="scope">
          <div style="display: flex">
            <el-button
              type="text"
              v-auth="'examSetting_examSettingDetails'"
              @click="
                $router.push({
                  path: '/examSettingDetails',
                  query: { id: scope.row.id, examState: scope.row.examState },
                })
              "
              >设置</el-button
            >
            <!-- <div v-if="scope.row.examState == 1">{{ scope.row.examState == 1 ? "设置" : "查看" }}
              <span style="color: #eee">&nbsp;|&nbsp;</span>
              <el-button type="text" @click="deleteExaminationSetting(scope.row.id)">
                删除</el-button>
            </div> -->
          </div>
        </template>
      </el-table-column>
    </el-table>
    <!-- 分页 -->
    <el-pagination
      @size-change="handleSizeChange"
      @current-change="handleCurrentChange"
      :current-page="params.pageNumber"
      :page-sizes="[10, 20, 30, 40]"
      :page-size="params.pageSize"
      layout="total, sizes, prev, pager, next, jumper"
      :total="params.total"
    >
    </el-pagination>

    <!-- 添加考试 addTestDia-->
    <el-dialog title="添加考试" width="400px" :visible.sync="addTestDia">
      <el-form :model="addTestDiaForm" :rules="addTestRules" ref="addTest">
        <el-form-item label="考试项目" prop="addCourseIds" label-width="70px">
          <el-cascader
            size="mini"
            clearable
            style="width: 290px"
            v-model="addTestDiaForm.addCourseIds"
            :show-all-levels="false"
            :props="subjectTreeProps"
            placeholder="请选择所属科目"
            :options="subjectTreeList"
            @change="subjectSearchChange(1)"
          ></el-cascader>
        </el-form-item>
        <el-form-item label="考试期数" label-width="70px" prop="addSequence">
          <el-input
            size="mini"
            style="width: 290px"
            v-model="addTestDiaForm.addSequence"
            disabled
            type="text"
          ></el-input>
        </el-form-item>
        <el-form-item label="报名时间" label-width="70px" prop="addTestsignTime">
          <el-date-picker
            v-model="addTestDiaForm.addTestsignTime"
            :picker-options="testsignStartDate"
            size="mini"
            style="width: 290px"
            type="datetimerange"
            range-separator="至"
            format="yyyy-MM-dd HH:mm"
            value-format="yyyy-MM-dd HH:mm"
            start-placeholder="开始时间"
            end-placeholder="结束时间"
            @blur="change(addTestDiaForm.addTestsignTime)"
          >
          </el-date-picker>
        </el-form-item>
        <!-- <el-form-item label="考试日期" label-width="70px" prop="addTestexamTime">
          <el-date-picker :key="num" v-model="addTestDiaForm.addTestexamTime" :picker-options="testexamStartDate" size="mini" style="width: 290px" type="daterange" range-separator="至" format="yyyy-MM-dd" value-format="yyyy-MM-dd" start-placeholder="开始日期" end-placeholder="结束日期">
          </el-date-picker>
        </el-form-item> -->
      </el-form>
      <div slot="footer" class="dialog-footer">
        <!-- addTestDia = false -->
        <el-button @click="addTestDiaHidden">取 消</el-button>
        <el-button type="primary" @click="addTest">确 定</el-button>
      </div>
    </el-dialog>

    <!-- 抓拍设置 -->
    <el-dialog width="350px" top="30vh" title="抓拍设置" :visible.sync="captureDia">
      <el-form :model="captureParams">
        <el-form-item label="抓拍间隔时间" label-width="90px">
          <el-input
            type="number"
            v-model="captureParams.duration"
            min="0"
            size="mini"
            style="width: 80px"
          ></el-input>
          <span style="margin-left: 5px">秒</span>
        </el-form-item>
        <el-form-item label="抓拍次数上限" label-width="90px">
          <el-input
            type="number"
            v-model="captureParams.count"
            min="0"
            size="mini"
            style="width: 80px"
          ></el-input>
          <span style="margin-left: 5px">次</span>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="captureDia = false">取 消</el-button>
        <el-button type="primary" @click="captureSet">确 定</el-button>
      </div>
    </el-dialog>
  </div>
</template>
<script>
// import { delete } from "vue/types/umd";
let endTime = "";
export default {
  data() {
    return {
      num: 0,
      testsignStartDate: {
        // 报名时间限制
        disabledDate(time) {
          let _now = Date.now() - 24 * 60 * 60 * 1000;
          return time.getTime() < _now;
        },
      },
      testexamStartDate: {
        // 考试日期限制
        disabledDate(time) {
          let timer = new Date(endTime) - 24 * 60 * 60 * 1000;
          return time.getTime() < timer;
        },
      },
      addTestRules: {
        addCourseIds: {
          required: true,
          message: "请输入活动名称",
          trigger: "change",
        },
        addTestsignTime: {
          required: true,
          message: "请输入报名时间",
          trigger: "change",
        },
        // addTestexamTime: {
        //   required: true,
        //   message: "请输入考试日期",
        //   trigger: "change",
        // },
        addSequence: {
          required: true,
          message: "请选择科目",
          trigger: "change",
        },
      },
      captureDia: false,
      captureParams: {
        // 抓拍数据
        duration: null,
        count: null,
      },
      addTestsignTime: [],
      // addTestexamTime: [],

      addTestDia: false,

      // addSequence: null,
      // 添加试卷参数
      addTestDiaForm: {
        subjectId: "",
        sequence: "",
        signBeginTime: "",
        signEndTime: "",
        examBeginTime: "",
        examEndTime: "",
        addTestsignTime: [],
        addTestexamTime: [],
        addSequence: "",
        addCourseIds: [],
      },
      testList: [],
      courseIds: [],
      addCourseId: "",
      params: {
        pageNumber: 1,
        pageSize: 10,
        sequence: "",
        subjectId: "",
        total: null,
      },
      subjectTreeProps: {
        value: "id",
        label: "name",
        children: "children",
      },
      subjectTreeList: [],
      options: [],
      classInfoId: "",
      addClassInfoId: "",
      searchForm: {},
    };
  },
  created() {
    this.getSubjectTreeList();
  },
  mounted() {
    this.getgetExamPageList({ pageNumber: 1, pageSize: 10 });
  },
  methods: {
    search() {
      this.getgetExamPageList(this.params);
    },
    change(val) {
      endTime = val[1];
      this.num += 1;
    },
    // 获取课程
    getSubjectTreeList() {
      this.api
        .getSubjectCourseTreeList()
        .then((result) => {
          this.teachingResearchList = [];
          if (result.data.length == 0) {
            this.loading = false;
            this.$message.error("暂无课程信息！");
          } else {
            for (let item of result.data) {
              if (item.children) {
                for (let items of item.children) {
                  delete items.children;
                  if (items.children) {
                  } else {
                    delete items.children;
                  }
                }
              } else {
                delete item.children;
              }
            }
            this.subjectTreeList = result.data;
            // this.courseIds = this.subjectTreeList[0].children[0].id;
            // this.searchForm.courseId = this.subjectTreeList[0].children[0].id;
            // this.homeworkData.courseId = this.subjectTreeList[0].children[0].id;
            // this.getClassInfoList();
          }
        })
        .catch((error) => {
          console.log(error);
        });
    },

    getClassInfoList(id) {
      this.api.signInLog
        .getClassInfoList({ subjectCourseId: id })
        .then((result) => {
          this.options = result.data;
        })
        .catch((error) => {
          console.log(error);
        });
    },

    // 获取期数
    subjectSearchChange(val) {
      if (val == 0) {
        // let params = {
        //   pageNumber: this.params.pageNumber,
        //   pageSize: this.params.pageSize,
        //   subjectId: this.courseIds[1],
        // };

        this.params = {
          pageNumber: 1,
          pageSize: 10,
          sequence: "",
          subjectId: this.courseIds[1],
          total: null,
        };

        // this.getgetExamPageList(params); // 不选期数展示所有期数数据
        this.searchForm.courseId = this.courseIds[1];
        this.getClassInfoList(this.searchForm.courseId);

        this.options = [];
        this.classInfoId = "";
        this.ChapterTree = [];
        this.scheduleInfoId = "";
      } else {
        // 添加考试获取期数
        this.addCourseId = this.addTestDiaForm.addCourseIds[1];
        this.api.signInLog.getSequence({ subjectId: this.addCourseId }).then((res) => {
          // console.log(res);
          this.addTestDiaForm.addSequence = `第${res.data}期`;
          this.addTestDiaForm.sequence = res.data;
        });
      }
    },

    // 获取期数 接口
    getClassInfoList(id) {
      this.api.signInLog
        .getSequenceListBySubjectId({ subjectId: id })
        .then((result) => {
          this.options = result.data;
          this.options.forEach((item) => {
            item.sequenceText = `第${item.sequence}期`;
          });
          // console.log(this.options);
        })
        .catch((error) => {
          console.log(error);
        });
    },

    // 期数选择
    optionsChange(val) {
      // console.log(val);
      // this.params.sequence = val;
      // this.params.subjectId = this.searchForm.courseId;
      // this.getgetExamPageList(this.params);
      this.params = {
        pageNumber: 1,
        pageSize: 10,
        sequence: val,
        subjectId: this.searchForm.courseId,
        total: null,
      };
    },

    // 获取试卷列表
    getgetExamPageList(params) {
      if (params.sequence == "") {
        delete params.sequence;
      }
      this.api.signInLog.getExamPageList(params).then((res) => {
        // console.log(res);
        if (res.code == 200) {
          this.testList = res.data.records;
          this.params.pageNumber = res.data.current;
          this.params.pageSize = res.data.size;
          this.params.total = res.data.total;
          this.params.subjectId = this.courseIds[1];
          // console.log(this.params);
        }
      });
    },

    // 添加考试
    addTest() {
      this.$refs.addTest.validate((Boolean) => {
        if (Boolean) {
          // console.log(123);
          this.addTestDiaForm.subjectId = this.addTestDiaForm.addCourseIds[1];
          this.addTestDiaForm.signBeginTime =
            this.addTestDiaForm.addTestsignTime[0] + ":00";
          this.addTestDiaForm.signEndTime =
            this.addTestDiaForm.addTestsignTime[1] + ":00";

          // this.addTestDiaForm.examBeginTime = this.addTestDiaForm.addTestexamTime;
          // this.addTestDiaForm.examEndTime = this.addTestDiaForm.addTestexamTime;
          // console.log(this.addTestDiaForm.addTestexamTime);

          // this.addTestDiaForm.examBeginTime = this.addTestDiaForm.addTestexamTime[0] + ' 00:00:00';
          // this.addTestDiaForm.examEndTime = this.addTestDiaForm.addTestexamTime[1] + ' 00:00:00';
          console.log(this.addTestDiaForm);
          this.api.signInLog.addExaminationSetting(this.addTestDiaForm).then((res) => {
            if (res.code == 200) {
              this.$message.success("添加成功");
              this.addTestDia = false;
              this.addCourseIds = [];
              this.getgetExamPageList({ pageNumber: 1, pageSize: 10 });
              endTime = "";
            } else {
              this.$message.error(res.message);
            }
          });
        }
      });
    },
    // 抓拍设置
    captureSet() {
      // console.log(this.captureParams);
      this.api.signInLog.addExaminationPhotoSetting(this.captureParams).then((res) => {
        if (res.code == 200) {
          this.$message.success("操作成功");
          this.captureDia = false;
        }
      });
    },
    addCapture() {
      this.api.signInLog.getExaminationPhotoSetting().then((res) => {
        if (res.code == 200) {
          if (res.data) {
            this.captureParams.duration = res.data.duration;
            this.captureParams.count = res.data.count;
          }
          this.captureDia = true;
        }
      });
    },
    // 清除试卷缓存
    clearTestCache() {
      this.api.signInLog.cleanExaminationExamQuestionCache().then((res) => {
        if (res.code == 200) {
          this.$message.success("操作成功");
        }
      });
    },
    addTestDiaHidden() {
      this.addTestDia = false;
      this.addTestDiaForm.addTestexamTime = [];
      this.addTestDiaForm.addTestsignTime = [];
    },
    // 删除考试
    deleteExaminationSetting(id) {
      let arr = [];
      let obj = { id };
      arr.push(obj);
      this.api.signInLog.deleteExaminationSetting(arr).then((res) => {
        if (res.code == 200) {
          this.$message.success(res.message);
          this.addCourseIds = [];
          this.getgetExamPageList({ pageNumber: 1, pageSize: 10 });
          endTime = "";
        }
        // console.log(res);
      });
    },

    handleSizeChange(val) {
      // console.log(val);
      let params = this.params;
      params.pageSize = val;
      this.getgetExamPageList(params);
    },
    handleCurrentChange(val) {
      // console.log(val);
      let params = this.params;
      params.pageNumber = val;
      this.getgetExamPageList(params);
    },
  },
};
</script>

<style scoped>
.exam-set-page {
  box-sizing: border-box;
  padding: 20px;
  min-height: 700px;
  background-color: #fff;
}
.search-box {
  display: flex;
}
.secend-btn {
  margin: 20px 0;
  display: flex;
}
</style>



// WEBPACK FOOTER //
// src/components/fullTruthModelTest/examSetting.vue